<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('contract')">
            <app-default-button
                v-if="$can('view_all_templates')"
                :url="'/template'"
                :title="$t('template')"
                btn-class="btn btn-primary mr-2"
            />
            <app-default-button
                :title="$fieldTitle('add', 'contract', true)"
                v-if="$can('create_designations')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="contract-table"
            :options="options"
            @action="triggerActions"
        />

        <app-contract-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('contract-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import { CONTRACT } from "../../../../Config/ApiUrl";
import ContractMixin from "../../../Mixins/ContractMixin";

export default {
        name: "AppContracts",
        mixins: [HelperMixin, ContractMixin],
        data() {
            return {
                isModalActive: false,
                selectedUrl: '',
            }
        },

        methods: {
            async triggerActions(row, action, active) {
                if (action.title === this.$t('edit')) {
                    this.selectedUrl = `${CONTRACT}/${row.id}`;
                    this.isModalActive = true;
                } else if (action.title === this.$t('open_in_new_tab')) {
                    window.open(row.detail_url, '_blank');
                } else {
                    this.getAction(row, action, active)
                }
            },

            openModal() {
                this.isModalActive = true;
                this.selectedUrl = ''
            },
        },
    }
</script>
